import { useEffect, useRef, useState } from "react";
// import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { fetchShowingOffer } from "../signals/offerData.signal";
import LazyImage from "./LazyImage";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import translateText, { currentLanguage } from "../signals/language.signal";

const OfferBox = () => {
  const videoRefs = useRef([]);
  const [isPlaying, setPlaying] = useState({});

  const handleVideoClick = (index) => {
    const video = videoRefs.current[index];

    if (!video) return;

    if (video.paused) {
      video.play();
      setPlaying((prevState) => ({ ...prevState, [index]: true }));
    } else {
      video.pause();
      video.currentTime = 0;
      setPlaying((prevState) => ({ ...prevState, [index]: false }));
    }
  };

  const handleMouseLeave = (index) => {
    const video = videoRefs.current[index];

    if (!video || !isPlaying[index]) return;

    video.pause();
    video.currentTime = 0;
    setPlaying((prevState) => ({ ...prevState, [index]: false }));
  };

  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchShowingOffer();
        setItems(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          className="align-items-sm-center loginContaner d-flex justify-content-center w-100 p-3"
        >
          <div className="overflow-hidden  bg-white p-0 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
            <div className="w-100 position-relative d-flex flex-column">
              {item.OFFER_TYPE === "IMG" ? (
                <>
                  <LazyImage
                    src={item.OFFER_IMG}
                    alt={translateText(currentLanguage.value, "OfferAlt")}
                    height="100%"
                    width="100%"
                    style={{
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                    className="rounded-3"
                  />
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center flex-column ">
                    <div className="w-100">
                      <p
                        className="m-0 "
                        style={{
                          color: primary.value,
                          fontWeight: "700",
                        }}
                      >
                        {item.OFFER_TITLE}
                      </p>
                      <p className="m-0" style={{ fontSize: "12px" }}>
                        {item.OFFER_TEXT}
                      </p>
                      {item.BUTTON_URL ? (
                        <button
                          onClick={() => (window.location.href = item.BUTTON_URL)}
                          className="btn  mt-2"
                          style={{background: primary.value, color: primaryFount.value}}
                        >
                          {translateText(currentLanguage.value, "ShowMore")}
                        </button>
                      ) : null}
                    </div>
                    <div className="d-flex justify-content-end w-100">
                      <p className="m-0 " style={{ fontSize: "8px" }}>
                        {translateText(currentLanguage.value, "ValidTill")}
                        {item.OFFER_END_DATE}
                      </p>
                    </div>
                  </div>
                </>
              ) : item.OFFER_TYPE === "VIDEO" ? (
                <>
                  <video
                    ref={(el) => (videoRefs.current[index] = el)}
                    className="w-100 rounded-3"
                    loop
                    controls
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                    onClick={() => handleVideoClick(index)}
                    onMouseLeave={() => handleMouseLeave(index)}
                  >
                    <source src={item.OFFER_IMG} type="video/mp4" />
                    {translateText(currentLanguage.value, "VideoTagNotSupported")}
                  </video>
                  <div className="w-100 p-2 d-flex justify-content-between align-items-center flex-column ">
                    <div className="w-100">
                      <p
                        className="m-0 "
                        style={{
                          color: primary.value,
                          fontWeight: "700",
                        }}
                      >
                        {item.OFFER_TITLE}
                      </p>
                      <p className="m-0" style={{ fontSize: "12px" }}>
                        {item.OFFER_TEXT}
                      </p>
                      {item.BUTTON_URL ? (
                        <button
                          onClick={() => (window.location.href = item.BUTTON_URL)}
                          className="btn mt-2"
                          style={{background: primary.value, color: primaryFount.value}}
                        >
                          {translateText(currentLanguage.value, "ShowMore")}
                        </button>
                      ) : null}
                    </div>
                    <div className="d-flex justify-content-end w-100">
                      <p className="m-0 " style={{ fontSize: "8px" }}>
                        {translateText(currentLanguage.value, "ValidTill")}
                        {item.OFFER_END_DATE}
                      </p>
                    </div>
                  </div>
                </>
              ) : item.OFFER_TYPE === "TEXT" ? (
                <div className="w-100 p-2 d-flex justify-content-between align-items-center flex-column ">
                  <div className="w-100">
                    <p
                      className="m-0 "
                      style={{
                        color: primary.value,
                        fontWeight: "700",
                      }}
                    >
                      {item.OFFER_TITLE}
                    </p>
                    <p className="m-0" style={{ fontSize: "12px" }}>
                      {item.OFFER_TEXT}
                    </p>
                    {item.BUTTON_URL ? (
                      <button
                        onClick={() => (window.location.href = item.BUTTON_URL)}
                        className="btn mt-2"
                        style={{background: primary.value, color: primaryFount.value}}
                      >
                        {translateText(currentLanguage.value, "ShowMore")}
                      </button>
                    ) : null}
                  </div>
                  <div className="d-flex justify-content-end w-100">
                    <p className="m-0 " style={{ fontSize: "8px" }}>
                      {translateText(currentLanguage.value, "ValidTill")}
                      {item.OFFER_END_DATE}
                    </p>
                  </div>
                </div>
              ) : (
                <div>{translateText(currentLanguage.value, "UnknownOfferType")}</div>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default OfferBox;
